import React from 'react';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {FormControlGroup} from 'app/general/forms';
import {gt} from 'app/utils/i18n';

interface Props {
  description: string | null;
  onChange: (description: string) => unknown;
}

export function TaskDescriptionField({description, onChange}: Props) {
  return (
    <div className="form-row">
      <FormControlGroup className="col-12" field="description">
        <label htmlFor="task-description-field">
          {gt('Task Name')}
          <LazyTooltip
            tooltip={
              <span>{gt('The name is shown whenever you see this task.')}</span>
            }
          >
            <i className="ml-1 fa fa-question-circle" />
          </LazyTooltip>
        </label>
        <input
          id="task-description-field"
          type="text"
          className="form-control"
          value={description ?? ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder={gt('e.g. Onboarding for Susan')}
        />
      </FormControlGroup>
    </div>
  );
}
